import { Box, Divider } from '@material-ui/core';
import * as R from 'ramda';
import React, { ReactElement, useMemo } from 'react';

import { ChapterZone } from '../../../models';
import { Chapter, LinkChapter } from '../../../redux';
import { CardTemplateContainer } from '../../atoms';
import { ChapterCard } from '../../molecules';

import './chapter-overview.styles.scss';

export interface IChapterOverviewProps {
	chapters: Chapter[];
	linkChapters: LinkChapter[];
	hideBottom?: boolean;
	onNavigate?: (chapter: Chapter | LinkChapter) => void;
}

type OverviewChapter = Chapter | LinkChapter;

export function ChapterOverview(props: IChapterOverviewProps): ReactElement {
	const { chapters, linkChapters, hideBottom, onNavigate } = props;

	const topZone: OverviewChapter[] = useMemo(
		() => getChaptersFromZone(ChapterZone.TOP),
		[chapters]
	);

	const bottomZone: OverviewChapter[] = useMemo(
		() => getChaptersFromZone(ChapterZone.BOTTOM),
		[chapters]
	);

	function getChaptersFromZone(zone: ChapterZone): OverviewChapter[] {
		return R.sortWith([R.ascend(R.prop('order'))])(
			[...chapters, ...linkChapters].filter(
				(chapter: OverviewChapter) => chapter.zone === zone
			)
		) as Chapter[];
	}

	return (
		<Box className="chapter-overview" data-mdat-module="chapter-overview">
			<CardTemplateContainer columns={4}>
				{topZone.map((chapter: Chapter) => (
					<ChapterCard
						onNavigate={onNavigate}
						key={chapter.id}
						chapter={chapter}
					/>
				))}
			</CardTemplateContainer>
			{!hideBottom && (
				<>
					<Divider className="chapter-zone-divider" />
					<CardTemplateContainer columns={4}>
						{bottomZone.map((chapter: Chapter) => (
							<ChapterCard
								onNavigate={onNavigate}
								key={chapter.id}
								chapter={chapter}
							/>
						))}
					</CardTemplateContainer>
				</>
			)}
		</Box>
	);
}
